import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { SlingoCompletionReason } from "slingo/integration/slingo-schema";
import { SlingoGameProgressResult } from "slingo/model/results/slingo-game-progress-result";

export class SlingoIsMaximumStakeLimitDecision extends Decision {
    public evaluate(): Exit {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const gameProgressResult = record.getFirstResultOfType(SlingoGameProgressResult);

        if (gameProgressResult && gameProgressResult.completionReason === SlingoCompletionReason.MAXIMUM_STAKE_LIMIT) {
            return Exit.True;
        }

        return Exit.False;
    }
}